import calendarTime from './calendar-time.webp';
import email from './email.webp';
import findVet from './find-vet.webp';
import testimonial1 from './testimonials/testimonial1.webp';
import testimonial2 from './testimonials/testimonial2.webp';
import testimonial3 from './testimonials/testimonial3.webp';
import testimonial4 from './testimonials/testimonial4.webp';
import testimonial5 from './testimonials/testimonial5.webp';

export const STEP_IMAGES = [findVet, calendarTime, email];

export const TESTIMONIAL_IMAGES = [
  testimonial1,
  testimonial2,
  testimonial3,
  testimonial4,
  testimonial5,
];
